<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <template v-for="(row, index) in detailData.list">
                        <el-form
                            ref="detailData"
                            :model="detailData"
                            label-position="top"
                            size="small"
                            :key="index"
                        >
                            <el-form-item label="产品：">
                                <el-row :gutter="20">
                                    <template v-for="(row, index) in row.products">
                                        <el-col :key="index" :span="8"
                                            >{{ row.product.name }}（{{ row.price }}）</el-col
                                        >
                                    </template>
                                </el-row>
                            </el-form-item>
                            <el-form-item label="经营地区：">
                                <el-row :gutter="20">
                                    <template v-for="(row, index) in row.area">
                                        <el-col :key="index" :span="12">{{ row.join('') }}</el-col>
                                    </template>
                                </el-row>
                            </el-form-item>
                            <el-row :gutter="20">
                                <template v-for="(row, index) in row.qualification">
                                    <el-col :key="index" :span="12" v-if="row.value">
                                        <el-form-item :label="row.name + '：'">
                                            <el-image
                                                :src="'http://img.hemutx.com/' + row.value"
                                                fit="cover"
                                            ></el-image>
                                        </el-form-item>
                                    </el-col>
                                </template>
                            </el-row>
                            <el-form-item label="扶持政策：">{{ row.support }}</el-form-item>
                            <el-form-item label="合作约定：">{{ row.agreement }}</el-form-item>
                            <el-form-item
                                v-if="!row.status && $store.state.userInfo.identity === 1"
                            >
                                <el-button
                                    type="primary"
                                    size="small"
                                    :loading="detailData.loading.submit"
                                    @click="VerifyCooperation(1)"
                                    >审核通过</el-button
                                >
                                <el-button
                                    size="small"
                                    :loading="detailData.loading.submit"
                                    @click="VerifyCooperation(2)"
                                    >审核不通过</el-button
                                >
                            </el-form-item>
                        </el-form>
                    </template>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    inject: ['reload'],
    props: ['detailParam'],
    data() {
        return {
            detailData: {
                loading: {
                    main: false
                },
                title: '客户详情',
                list: []
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            if (this.detailParam.row.customer_id) {
                this.GetCooperation()
            }
        })
    },
    methods: {
        GetCooperation() {
            this.detailData.loading.main = true
            this.$request({
                url: '/api/v1/customer_user_one',
                params: {
                    ...this.detailParam.row
                }
            }).then(res => {
                if (!res.status) {
                    this.detailData.loading.main = false
                    res.data.list.forEach(row => {
                        row.area = JSON.parse(row.area)
                        row.qualification = JSON.parse(row.qualification)
                    })
                    this.detailData.list = res.data.list
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        VerifyCooperation(status) {
            this.$confirm(
                status === 1
                    ? '经销/代理商审核通过, 是否继续?'
                    : '经销/代理商审核不通过, 是否继续?',
                '警告',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }
            )
                .then(() => {
                    this.$request({
                        url: '/api/v1/customer_verify',
                        params: {
                            customer_user_id: this.detailParam.row.customer_id,
                            status: status
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.reload()
                        }
                    })
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
